import SignInPage from './pages/SignInPage';
import SignOutPage from './pages/SignOutPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AuthPage from './pages/AuthPage/AuthPage';
import WelcomePage from './pages/WelcomePage';
import RootPage from './pages/RootPage';
import DashboardPage from './pages/DashboardPage';
import ApiDescriptionPage from './pages/ApiDescriptionPage';
import DataSourcesPage from './pages/DataSourcesPage';
import ViewerPage from './pages/ViewerPage';
import DataAnnotationPage from './pages/DataAnnotationPage';
import AnnotationVerificationPage from './pages/AnnotationVerificationPage';
import AiTrainingPage from './pages/AiTrainingPage';
import BlackHolePage from './pages/BlackHolePage';

import IMAGE_DASHBOARD from './assets/Images/MenuDashboard.svg';
import IMAGE_API_DESCRIPTION from './assets/Images/MenuApiDescription.svg';
import IMAGE_DATA_SOURCES from './assets/Images/MenuDataSources.svg';
import IMAGE_VIEWER from './assets/Images/MenuViewer.svg';
import IMAGE_DATA_ANNOTATION from './assets/Images/MenuDataAnnotation.svg';
import IMAGE_ANNOTATION_VERIFICATION from './assets/Images/MenuAnnotationVerification.svg';
import IMAGE_AI_TRAINING from './assets/Images/MenuAiTraining.svg';

const routes = [
  // AUTH ROUTES
  {
    path: '/sign-in',
    name: 'SIGN_IN',
    component: SignInPage,
    isExact: true,
    isAuth: false,
    isMenu: false,
  },
  {
    path: '/sign-out',
    name: 'SIGN_OUT',
    component: SignOutPage,
    isExact: true,
    isAuth: true,
    isMenu: false,
  },
  {
    path: '/forgot-password',
    name: 'FORGOT_PASSWORD',
    component: ForgotPasswordPage,
    isExact: true,
    isAuth: false,
    isMenu: false,
  },
  {
    path: '/auth',
    name: 'AUTH',
    component: AuthPage,
    isExact: true,
    isAuth: false,
    isMenu: false,
  },
  {
    path: '/welcome',
    name: 'WELCOME',
    component: WelcomePage,
    isExact: true,
    isAuth: false,
    isMenu: false,
  },
  // CLIENT ROUTES
  {
    path: '/dashboard',
    name: 'DASHBOARD',
    component: DashboardPage,
    isExact: true,
    isAuth: true,
    isMenu: true,
    image: IMAGE_DASHBOARD,
  },
  {
    path: '/api-description',
    name: 'API_DESCRIPTION',
    component: ApiDescriptionPage,
    isExact: true,
    isAuth: true,
    isMenu: true,
    image: IMAGE_API_DESCRIPTION,
  },
  {
    path: '/data-sources',
    name: 'DATA_SOURCES',
    component: DataSourcesPage,
    isExact: true,
    isAuth: true,
    isMenu: true,
    image: IMAGE_DATA_SOURCES,
  },
  {
    path: '/viewer',
    name: 'VIEWER',
    component: ViewerPage,
    isExact: true,
    isAuth: true,
    isMenu: true,
    image: IMAGE_VIEWER,
  },
  {
    path: '/data-annotation',
    name: 'DATA_ANNOTATION',
    component: DataAnnotationPage,
    isExact: true,
    isAuth: true,
    isMenu: true,
    isHiddenOnMobile: true,
    image: IMAGE_DATA_ANNOTATION,
  },
  {
    path: '/annotation-verification',
    name: 'ANNOTATION_VERIFICATION',
    component: AnnotationVerificationPage,
    isExact: true,
    isAuth: true,
    isMenu: true,
    isHiddenOnMobile: true,
    image: IMAGE_ANNOTATION_VERIFICATION,
  },
  {
    path: '/ai-training',
    name: 'AI_TRAINING',
    component: AiTrainingPage,
    isExact: true,
    isAuth: true,
    isMenu: true,
    image: IMAGE_AI_TRAINING,
  },
  // OTHER ROUTES
  {
    path: '/',
    name: 'ROOT',
    component: RootPage,
    isExact: true,
    isMenu: false,
  },
  {
    name: 'BLACK-HOLE',
    component: BlackHolePage,
    isMenu: false,
  },
];

export default routes;
